class FooterAnalytics {
  els;

  constructor(footerLinkItems) {
    this.els = footerLinkItems;
    this.bindListeners();
  }

  bindListeners() {
    this.els.forEach((footerItem) => {
      footerItem.addEventListener("click", this.dataPush.bind(this));
    })
  }

  dataPush(e) {
    e.preventDefault();

    const href = e.target.href;
    const dataName = e.target.innerHTML;
    const evento = {
      event: 'click_footer',
      item_nombre: dataName
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
    //console.log('Evento enviado al dataLayer:', evento);

    
    setTimeout(() => {
      window.location.href = href;
    }, 200);
    
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const footerLinkItems = document.querySelectorAll('#site-footer a');
  if(footerLinkItems.length > 0) {
    new FooterAnalytics(footerLinkItems);
  }
});
